<template>
    <TsContent model="ribbon" :path="$route.fullPath" />
</template>